// extracted by mini-css-extract-plugin
export default {"chip":"small_chip-module__chip--2wqr4","warning":"small_chip-module__warning--1OYWX","primary":"small_chip-module__primary--4sVZ5","secondary":"small_chip-module__secondary--2_OBM"};